var map = {
	"./404.svg": "./src/icons/svg/404.svg",
	"./application_mgr.svg": "./src/icons/svg/application_mgr.svg",
	"./bug.svg": "./src/icons/svg/bug.svg",
	"./call.svg": "./src/icons/svg/call.svg",
	"./chart.svg": "./src/icons/svg/chart.svg",
	"./circle.svg": "./src/icons/svg/circle.svg",
	"./clipboard.svg": "./src/icons/svg/clipboard.svg",
	"./component.svg": "./src/icons/svg/component.svg",
	"./dashboard.svg": "./src/icons/svg/dashboard.svg",
	"./dashboard_new.svg": "./src/icons/svg/dashboard_new.svg",
	"./device_mgr.svg": "./src/icons/svg/device_mgr.svg",
	"./documentation.svg": "./src/icons/svg/documentation.svg",
	"./drag.svg": "./src/icons/svg/drag.svg",
	"./edit.svg": "./src/icons/svg/edit.svg",
	"./education.svg": "./src/icons/svg/education.svg",
	"./email.svg": "./src/icons/svg/email.svg",
	"./equipment_list.svg": "./src/icons/svg/equipment_list.svg",
	"./equipment_mgr.svg": "./src/icons/svg/equipment_mgr.svg",
	"./example.svg": "./src/icons/svg/example.svg",
	"./excel.svg": "./src/icons/svg/excel.svg",
	"./exit_fullscreen.svg": "./src/icons/svg/exit_fullscreen.svg",
	"./eye.svg": "./src/icons/svg/eye.svg",
	"./eye_open.svg": "./src/icons/svg/eye_open.svg",
	"./file_excel.svg": "./src/icons/svg/file_excel.svg",
	"./file_image.svg": "./src/icons/svg/file_image.svg",
	"./file_pdf.svg": "./src/icons/svg/file_pdf.svg",
	"./file_ppt.svg": "./src/icons/svg/file_ppt.svg",
	"./file_unknown.svg": "./src/icons/svg/file_unknown.svg",
	"./file_word.svg": "./src/icons/svg/file_word.svg",
	"./file_zip.svg": "./src/icons/svg/file_zip.svg",
	"./form.svg": "./src/icons/svg/form.svg",
	"./fullscreen.svg": "./src/icons/svg/fullscreen.svg",
	"./guidance.svg": "./src/icons/svg/guidance.svg",
	"./guidance_1.svg": "./src/icons/svg/guidance_1.svg",
	"./guide.svg": "./src/icons/svg/guide.svg",
	"./home_page.svg": "./src/icons/svg/home_page.svg",
	"./icon.svg": "./src/icons/svg/icon.svg",
	"./incoming_inspection.svg": "./src/icons/svg/incoming_inspection.svg",
	"./international.svg": "./src/icons/svg/international.svg",
	"./knowledge_library_mgr.svg": "./src/icons/svg/knowledge_library_mgr.svg",
	"./language.svg": "./src/icons/svg/language.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./list.svg": "./src/icons/svg/list.svg",
	"./lock.svg": "./src/icons/svg/lock.svg",
	"./menu_mgr.svg": "./src/icons/svg/menu_mgr.svg",
	"./message.svg": "./src/icons/svg/message.svg",
	"./money.svg": "./src/icons/svg/money.svg",
	"./nested.svg": "./src/icons/svg/nested.svg",
	"./password.svg": "./src/icons/svg/password.svg",
	"./pdf.svg": "./src/icons/svg/pdf.svg",
	"./people.svg": "./src/icons/svg/people.svg",
	"./peoples.svg": "./src/icons/svg/peoples.svg",
	"./project_mgr.svg": "./src/icons/svg/project_mgr.svg",
	"./q_a_document_mgr.svg": "./src/icons/svg/q_a_document_mgr.svg",
	"./qq.svg": "./src/icons/svg/qq.svg",
	"./remote_guidance.svg": "./src/icons/svg/remote_guidance.svg",
	"./report.svg": "./src/icons/svg/report.svg",
	"./role_mgr.svg": "./src/icons/svg/role_mgr.svg",
	"./safe_shield.svg": "./src/icons/svg/safe_shield.svg",
	"./scan.svg": "./src/icons/svg/scan.svg",
	"./search.svg": "./src/icons/svg/search.svg",
	"./shopping.svg": "./src/icons/svg/shopping.svg",
	"./size.svg": "./src/icons/svg/size.svg",
	"./skill.svg": "./src/icons/svg/skill.svg",
	"./star.svg": "./src/icons/svg/star.svg",
	"./statistical_cake.svg": "./src/icons/svg/statistical_cake.svg",
	"./system_mgr.svg": "./src/icons/svg/system_mgr.svg",
	"./tab.svg": "./src/icons/svg/tab.svg",
	"./table.svg": "./src/icons/svg/table.svg",
	"./theme.svg": "./src/icons/svg/theme.svg",
	"./tree.svg": "./src/icons/svg/tree.svg",
	"./tree_table.svg": "./src/icons/svg/tree_table.svg",
	"./user.svg": "./src/icons/svg/user.svg",
	"./user_new.svg": "./src/icons/svg/user_new.svg",
	"./wechat.svg": "./src/icons/svg/wechat.svg",
	"./work_order.svg": "./src/icons/svg/work_order.svg",
	"./zip.svg": "./src/icons/svg/zip.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";